import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null=checking, false=none, obj=user
  const [favIds, setFavIds] = useState([]);

  const loadFavs = useCallback(() => {
    api.get("/favourites/ids").then((r) => setFavIds(r.data)).catch(() => setFavIds([]));
  }, []);

  const refresh = useCallback(() => {
    api.get("/customer/me")
      .then((r) => { setCustomer(r.data); loadFavs(); })
      .catch(() => setCustomer(false));
  }, [loadFavs]);

  useEffect(() => {
    // If returning from OAuth callback, let AuthCallback exchange the session first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const processSession = async (sessionId) => {
    const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
    setCustomer(data);
    loadFavs();
    return data;
  };

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await api.post("/customer/logout"); } catch (e) { /* best-effort: ignore logout network error */ }
    setCustomer(false);
    setFavIds([]);
  };

  const toggleFav = async (businessId) => {
    if (favIds.includes(businessId)) {
      setFavIds((f) => f.filter((x) => x !== businessId));
      await api.delete(`/favourites/${businessId}`).catch(() => {});
    } else {
      setFavIds((f) => [...f, businessId]);
      await api.post("/favourites", { business_id: businessId }).catch(() => {});
    }
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, favIds, refresh, processSession, loginWithGoogle, logout, toggleFav }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
